<template>
  <popup :close-action="emitCloseEvent" class="apple-promotion-success-popup" :buttons="buttons">
    <template v-slot:title>
      <img :src="require('@/assets/promotion-success.png')" class="image-in-popup padding-top-ml"/>
      <div class="ri-medium-bold-headline margin-top-l centered-title">ההטבה התעדכנה!</div>
    </template>
  </popup>
</template>

<script>
import BaseUI from '@riseupil/base-ui';

export default {
  name: 'ApplePromotionSuccessPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  methods: {
    emitCloseEvent() {
      this.$emit('close');
    },
  },
  computed: {
    buttons() {
      return [{
        title: 'חזרה לתזרים',
        action: this.emitCloseEvent,
      }];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.apple-promotion-success-popup {
  text-align: center;
  .popup {
    padding-bottom: 0;
  }
  .image-in-popup {
    height: 177px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .centered-title {
    text-align: center;
    margin-bottom: 22px;
  }
}
</style>
